import { CLUB_INIT_STATE, ClubState, CLUB_COMPONENT_INIT } from './club.state';
import * as ClubActions from './club.actions';
import { INIT_CLUB_STATE } from '@soposopo/sopo-models';
import { Action, createReducer, on } from '@ngrx/store';

const _clubReducer = createReducer(

    CLUB_INIT_STATE,

    on(
        ClubActions.activateClubComponent,
        (state, action) => ({
            ...state,
            activeComponent: action.component,
        })
    ),

    on(
        ClubActions.setChatLastMessageAction,
        (state, action) => ({
            ...state,
            lastReadMessageId: action.messageId,
        })
    ),

    on(
        ClubActions.clubEnteredAction,
        (state, action) => {
            if (state.id === action.clubId) return {...state}

            return {
                ...state,
                id: action.clubId,
                clubData: INIT_CLUB_STATE,
            }
        }
    ),

    on(
        ClubActions.clubLeftAction,
        (state, action) => ({
            ...state,
            id: 'SOPO',
            clubData: INIT_CLUB_STATE,
            activeComponent: {...CLUB_COMPONENT_INIT},
        })
    ),

    on(
        ClubActions.clubLoadedAction,
        (state, action) => ({
            ...state,
            clubData: action.clubData,
            listening: true,
        })
    ),

    on(
        ClubActions.clubLoadMessagesAction,
        (state, action) => ({
            ...state,
            messages: action.messages,
        })
    ),

    on(
        ClubActions.clubFetchFailedAction,
        (state, action) => ({
            ...state,
        })
    ),

    on(
        ClubActions.setClubListeningAction,
        (state, action) => ({
            ...state,
            listening: action.to,
        })
    ),

    on(
        ClubActions.setMembersListeningAction,
        (state, action) => ({
            ...state,
            membersState: {
                ...state.membersState,
                listening: action.to,
            },
        })
    ),

    on(
        ClubActions.membersLoadedAction,
        (state, action) => {
            const membersData = [...state.membersState.members];
            const addedMembers = action.members;
            membersData.push(...addedMembers);
            return {
                ...state,
                membersState: {
                    ...state.membersState,
                    numberOfMembers: action.numberOfMembers,
                    members: membersData,
                    listening: true,
                }
            }
        }
    ),

    on(
        ClubActions.memberModifiedAction,
        (state, action) => {
            const membersData = [...state.membersState.members];
            const modifiedMember = action.modifiedMember;
            let index = membersData.findIndex(member => member.id === modifiedMember.id);
            if(index > -1) membersData[index] = modifiedMember;
            else membersData.push(modifiedMember);

            return {
                ...state,
                membersState: {
                    ...state.membersState,
                    members: membersData,
                    listening: true,
                }
            }
        }
    ),

    on(
        ClubActions.memberRemovedAction,
        (state, action) => {
            const removedMember = action.removedMember;
            const membersData = [...state.membersState.members];
            let index = membersData.findIndex(member => member.id === removedMember.id);
            if(index > -1) membersData.splice(index, 1);

            return {
                ...state,
                membersState: {
                    ...state.membersState,
                    numberOfMembers: action.numberOfMembers,
                    members: membersData,
                    listening: true,
                }
            }
        }
    ),

    on(
        ClubActions.clearMembersState,
        (state, _) => ({
            ...state,
            membersState: {
                ...state.membersState,
                numberOfMembers: 0,
                members: [],
            }
        })
    ),

    on(
        ClubActions.clearMessages,
        (state, _) => ({
            ...state,
            messages: [],
        })
    ),
)

export function clubReducer(state: ClubState, action: Action) {
    return _clubReducer(state, action);
}
